export const FestivalPortalName = {
  headers: {
    main: 'headers-main' as const
  }
}
